<template>
  <div>
    <v-dialog
        v-model="dialog"
        max-width="800px"
        persistent
    >
      <template v-slot:activator="{ on, attrs }">
        <span v-if="buttonText != null">
          <v-btn
              class="mb-2"
              v-bind="attrs"
              v-on="on"
              :loading="loading"
          >
            {{ buttonText }}
          </v-btn>
        </span>
        <span v-else>
          <v-icon
              v-bind="$attrs"
              v-on="on"
              dark
              :loading="loading"
          >
            {{ icon }}
          </v-icon>
        </span>
      </template>
      <v-card>
        <v-card-title>
          <span class="text-h5">{{ title }}</span>
        </v-card-title>

        <v-card-text>
          <v-form
              ref="form"
              v-model="valid"
              lazy-validation
          >
            <v-row>
              <v-col cols="6">
                <v-text-field
                    v-model="value.part_number"
                    label="P/N"
                    required
                    :rules="valueRequired"
                    :counter="100"
                    outlined
                ></v-text-field>
              </v-col>
              <v-col cols="6">
                <v-select
                    v-model="value.provider"
                    :items="getProviderList"
                    item-text="name"
                    item-value='id'
                    label="Provider"
                    outlined
                ></v-select>
              </v-col>
              <v-col cols="3">
                <v-text-field
                    v-model="value.multiple"
                    label="Multiple"
                    type="Number"
                    required
                    :rules="valueRequired"
                    outlined
                ></v-text-field>
              </v-col>
              <v-col cols="2">
                <v-text-field
                    v-model="value.moq"
                    label="MOQ"
                    type="Number"
                    required
                    :rules="valueRequired"
                    outlined
                ></v-text-field>
              </v-col>
              <v-col cols="3">
                <v-text-field
                    v-model="value.instock"
                    label="Stock"
                    type="Number"
                    required
                    :rules="valueRequired"
                    outlined
                ></v-text-field>
              </v-col>
              <v-col cols="2">
                <v-text-field
                    v-model="value.lead"
                    label="Lead"
                    type="Number"
                    required
                    :rules="valueRequired"
                    outlined
                ></v-text-field>
              </v-col>
              <v-col cols="2">
                <v-checkbox
                    v-model="value.reel"
                    label="Reel"
                    outlined
                ></v-checkbox>
              </v-col>
              <v-col cols="12">
                <v-text-field
                    v-model="value.source"
                    label="Source URL"
                    type="url"
                    required
                    :roles="valueRequired"
                    outlined
                ></v-text-field>
              </v-col>
              <v-col cols="12">
                <BrandComponentPrices :prices.sync="value.prices"
                ></BrandComponentPrices>
              </v-col>
            </v-row>
          </v-form>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" text @click="onClose">Cancel</v-btn>
          <v-btn :disabled="!valid" color="blue darken-1" text @click="onSave">Save</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>


<script>

import {mapGetters, mapActions} from "vuex";
import BrandComponentPrices from "@/components/Brand/BrandComponentPrices";

export default {
  name: 'BrandComponentPSEditDialog',
  props: {
    icon: {type: String},
    buttonText: {type: String},
    title: {type: String},
    value: {type: Object},
    isNewItem: {type: Boolean, default: false},
    brandComponentId: {type: [Number, String], default: null}
  },

  components: {
    BrandComponentPrices,
  },

  computed: {
    ...mapGetters(['getProviderList']),
  },

  methods: {
    ...mapActions(['fetchBrandProviderList']),
    async fetchSavePCItem(item) {
      let self = this
      this.loading = true
      let csrfToken = this.$cookies.get('csrftoken')
      let data = new FormData()
      data.append('part_number', item.part_number)
      data.append('provider', item.provider)
      data.append('multiple', item.multiple)
      data.append('moq', item.moq)
      data.append('instock', item.instock)
      data.append('lead', item.lead)
      data.append('reel', item.reel)
      data.append('source', item.source)
      data.append('prices', JSON.stringify(item.prices))
      const requestParams = {
        method: "PATCH",
        headers: {
          'credentials': "same-origin",
          'X-CSRFToken': csrfToken,
        },
        body: data,
      };
      console.log('provider_component', item)
      let response = await fetch("/api/provider_component/" + item.id + "/", requestParams)
      if (!response.ok) {
        console.log(response)
        const result = await response.json()
        console.log(result)
        this._vm.$toast.error("Error:" + JSON.stringify(result), {timeout: 5000})
        this.loading = false
        return
      }
      let json = await response.json()
      this.loading = false
      this.$emit('change', json)
    },
    async fetchNewPCItem(item, brandComponentId) {
      this.loading = true
      let csrfToken = this.$cookies.get('csrftoken')
      let data = new FormData()
      console.log('provider_component', item, brandComponentId)
      data.append('part_number', item.part_number)
      data.append('provider', item.provider)
      data.append('brand_component', brandComponentId)
      data.append('multiple', item.multiple)
      data.append('moq', item.moq)
      data.append('instock', item.instock)
      data.append('lead', item.lead)
      data.append('reel', item.reel)
      data.append('source', item.source)
      data.append('prices', JSON.stringify(item.prices))
      const requestParams = {
        method: "POST",
        headers: {
          'credentials': "same-origin",
          'X-CSRFToken': csrfToken,
        },
        body: data,
      };
      let response = await fetch("/api/provider_component/", requestParams)
      if (!response.ok) {
        console.log(response)
        const result = await response.json()
        console.log(result)
        this._vm.$toast.error("Error:" + JSON.stringify(result), {timeout: 5000})
        this.loading = false
        return
      }
      let json = await response.json()
      this.loading = false
      this.$emit('input', json)
      this.$emit('change', json)
    },
    onClose() {
      this.dialog = false
    }
    ,
    onSave() {
      this.dialog = false
      if (this.isNewItem)
        this.fetchNewPCItem(this.value, this.brandComponentId)
      else
        this.fetchSavePCItem(this.value)
    }
    ,
    isValidPrices(prices) {
      console.log('isValidPrices', prices)
      return prices.isJSON()
    }
  },

  async mounted() {
    await this.fetchBrandProviderList();
  }
  ,

  data() {
    return {
      dialog: false,
      loading: false,
      valid: false,
      provider_data: "",
      valueRequired: [v => !!v || 'Value is required'],
      pricesRole: [
          v => !!v || 'Value is required',
          v => this.isValidPrices(v) || 'Value must be JSON format'
      ],

      // urlRules: [v => !!v || 'Title is required', v => (v && v.length <= 100) || 'Title must be less than 100 characters',],
    }
  }
  ,
}

</script>


<style scoped lang="scss">
</style>